"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

var _regeneratorRuntime = require("/opt/build/repo/docs/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.function.bind");

var _classCallCheck = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _possibleConstructorReturn = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSessionContext;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _querystring = _interopRequireDefault(require("querystring"));

var _Login = _interopRequireDefault(require("@arcblock/did-react/lib/Auth/Login"));

var _Service = _interopRequireDefault(require("../Service"));

var _Storage = _interopRequireDefault(require("../Storage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createSessionContext() {
  var storageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'login_token';
  var storage = (0, _Storage["default"])(storageKey);
  var getToken = storage.getToken,
      setToken = storage.setToken,
      removeToken = storage.removeToken;

  var SessionContext = _react["default"].createContext();

  var Provider = SessionContext.Provider,
      Consumer = SessionContext.Consumer;

  var SessionProvider = /*#__PURE__*/function (_react$default$Compon) {
    _inherits(SessionProvider, _react$default$Compon);

    var _super = _createSuper(SessionProvider);

    function SessionProvider(props) {
      var _this;

      _classCallCheck(this, SessionProvider);

      _this = _super.call(this, props);
      _this.service = (0, _Service["default"])(props.serviceHost, storage);
      _this.state = {
        error: '',
        loading: false,
        open: false,
        user: null
      };
      _this.onLogin = _this.onLogin.bind(_assertThisInitialized(_this));
      _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
      _this.login = _this.login.bind(_assertThisInitialized(_this));
      _this.logout = _this.logout.bind(_assertThisInitialized(_this));
      _this.refresh = _this.refresh.bind(_assertThisInitialized(_this));
      _this.loginListeners = [];
      return _this;
    }

    _createClass(SessionProvider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var token = getToken();

        if (token) {
          this.refresh(true);
          return;
        }

        if (typeof window !== 'undefined') {
          // If a login token exist in url, set that token in storage
          var params = _querystring["default"].parse(window.location.search.slice(1));

          if (params.loginToken) {
            setToken(params.loginToken);
            this.refresh(true);
            delete params.loginToken;
            var redirectUrl = "".concat(window.location.pathname, "?").concat(_querystring["default"].stringify(params));
            window.history.replaceState({}, window.title, redirectUrl);
            return;
          }
        }

        if (this.props.autoLogin) {
          this.setState({
            open: true
          });
        }
      }
    }, {
      key: "refresh",
      value: function () {
        var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var showProgress,
              _this$props,
              prefix,
              autoLogin,
              _yield$this$service$g,
              data,
              status,
              _args = arguments;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  showProgress = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                  _context.prev = 1;

                  if (!this.state.loading) {
                    _context.next = 5;
                    break;
                  }

                  // eslint-disable-next-line no-console
                  console.warn('SessionProvider.refresh is currently in progress, call it will be noop');
                  return _context.abrupt("return");

                case 5:
                  _this$props = this.props, prefix = _this$props.prefix, autoLogin = _this$props.autoLogin;
                  _context.next = 8;
                  return this.service.get("".concat(prefix, "/session").replace(/\/+/, '/'));

                case 8:
                  _yield$this$service$g = _context.sent;
                  data = _yield$this$service$g.data;
                  status = _yield$this$service$g.status;

                  if (status === 400) {
                    removeToken();

                    if (showProgress) {
                      this.setState({
                        user: null,
                        error: '',
                        loading: false
                      });
                    } else {
                      this.setState({
                        user: null,
                        error: ''
                      });
                    }
                  }

                  if (data.error) {
                    // Some thing went wrong
                    if (showProgress) {
                      this.setState({
                        error: data.error,
                        open: false,
                        loading: false
                      });
                    } else {
                      this.setState({
                        error: data.error,
                        open: false
                      });
                    }
                  } else if (data.user) {
                    // We have valid user
                    if (showProgress) {
                      this.setState(_objectSpread({
                        open: false,
                        loading: false
                      }, data));
                    } else {
                      this.setState(_objectSpread({
                        open: false
                      }, data));
                    }
                  } else {
                    // We are not logged in
                    // eslint-disable-next-line no-lonely-if
                    if (showProgress) {
                      this.setState(_objectSpread({
                        open: autoLogin,
                        loading: true
                      }, data));
                    } else {
                      this.setState(_objectSpread({
                        open: autoLogin
                      }, data));
                    }
                  }

                  _context.next = 19;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](1);
                  // eslint-disable-next-line no-console
                  console.error('SessionProvider.refresh error', _context.t0);

                  if (showProgress) {
                    this.setState({
                      error: _context.t0.message,
                      loading: false,
                      open: false
                    });
                  } else {
                    this.setState({
                      error: _context.t0.message,
                      open: false
                    });
                  }

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 15]]);
        }));

        function refresh() {
          return _refresh.apply(this, arguments);
        }

        return refresh;
      }()
    }, {
      key: "login",
      value: function login(done) {
        if (this.state.user) {
          return;
        }

        if (typeof done === 'function') {
          this.loginListeners.push(done);
        }

        this.setState({
          open: true
        });
      }
    }, {
      key: "logout",
      value: function logout(done) {
        removeToken();
        this.setState({
          user: null,
          error: '',
          open: false,
          loading: false
        }, done);
      }
    }, {
      key: "onLogin",
      value: function onLogin(_ref) {
        var _this2 = this;

        var loginToken = _ref.loginToken,
            sessionToken = _ref.sessionToken;
        var token = loginToken || sessionToken;

        if (token) {
          setToken(token);
          this.setState({
            loading: false
          }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var cb;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this2.refresh(true);

                  case 2:
                    while (_this2.loginListeners.length) {
                      cb = _this2.loginListeners.shift();

                      try {
                        cb();
                      } catch (err) {
                        // eslint-disable-next-line no-console
                        console.error('Error when call login listeners', err);
                      }
                    }

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
        }
      }
    }, {
      key: "onClose",
      value: function onClose() {
        this.setState({
          open: false
        });
        this.loginListeners = [];
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            children = _this$props2.children,
            action = _this$props2.action,
            prefix = _this$props2.prefix,
            locale = _this$props2.locale,
            timeout = _this$props2.timeout,
            extraParams = _this$props2.extraParams,
            autoLogin = _this$props2.autoLogin;
        var _this$state = this.state,
            user = _this$state.user,
            open = _this$state.open,
            loading = _this$state.loading;
        var state = {
          api: this.service,
          session: _objectSpread({}, this.state, {
            loading: autoLogin ? !user || loading : loading,
            login: this.login,
            logout: this.logout,
            refresh: this.refresh
          })
        };
        return _react["default"].createElement(Provider, {
          value: state
        }, !open && typeof children === 'function' ? children(state) : children, open && _react["default"].createElement(_Login["default"], {
          responsive: true,
          action: action || 'login',
          locale: locale,
          prefix: prefix,
          checkFn: this.service.get,
          onClose: this.onClose,
          onSuccess: this.onLogin,
          extraParams: extraParams,
          checkTimeout: timeout
        }));
      }
    }]);

    return SessionProvider;
  }(_react["default"].Component);

  SessionProvider.propTypes = {
    children: _propTypes["default"].any.isRequired,
    serviceHost: _propTypes["default"].string.isRequired,
    action: _propTypes["default"].string,
    prefix: _propTypes["default"].string,
    locale: _propTypes["default"].string,
    timeout: _propTypes["default"].number,
    autoLogin: _propTypes["default"].bool,
    extraParams: _propTypes["default"].object
  };
  SessionProvider.defaultProps = {
    locale: 'en',
    action: 'login',
    prefix: '/api/did',
    extraParams: {},
    autoLogin: false,
    timeout: 5 * 60 * 1000
  };

  function withSession(Component) {
    return function WithSessionComponent(props) {
      return _react["default"].createElement(Consumer, null, function (sessionProps) {
        return _react["default"].createElement(Component, Object.assign({}, props, sessionProps));
      });
    };
  } // eslint-disable-next-line object-curly-newline


  return {
    SessionProvider: SessionProvider,
    SessionConsumer: Consumer,
    SessionContext: SessionContext,
    withSession: withSession
  };
}